import { QuestionBase } from "./question-base";

export class TextAreaQuestion extends QuestionBase<string> {
  controlType = "textarea";
}
